import React, { FC } from 'react';
import style from './style.module.scss';

type Props = {
    children: React.ReactNode;
    id?: string;
}

const InfoSection: FC<Props> = ({ id, children }) => {


    return (
        <section className={style.infoSection} id={id}>
            {children}
        </section>
    );
}

export default InfoSection;